import { useContext, useEffect, useState } from "react";

import Axios from "axios";

import { Button, Card, Col, Form, Row } from "react-bootstrap";

import DashboardContext from "../../../Context";
import ModalDeleteAddress from "./ModalDeleteAddress";

import { useHistory } from "react-router-dom";
import FormAddMoudal from "./FormAddMoudal";
/**
 * این کامپوننت برای نمایش ادرس ها در پروفایل مشتری و ثبت سفارش است
 */
export default function FormAddres({
  id,
  handelDataAddress,
  handelDataAddressPart,
  isprofile,
  dataUpdate,
  isSelectedAddressPart,
  isContractual = false,
  close
}) {
  const { authentication, urldashboard, handelerrors } =
    useContext(DashboardContext);

  const { location } = useHistory();

  const [isRelode, setIsRelode] = useState(false);

  const handelReload = () => setIsRelode(!isRelode);

  const [dataFech, setDataFech] = useState([]);

  const [loading, setLoading] = useState(true);

  const dataFeching = async () => {
    try {
      const res = await Axios.post(
        `${urldashboard}/address/get/${id}`,
        JSON.stringify({ page: 1, pageSize: 50, search: "" }),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );

      const data = await res.data.data;
      setDataFech(data);
      setLoading(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    dataFeching();
    return () => {};
  }, [id, isRelode]);

  const handelOncheng = (event) => {
    if (event.target.checked) {
      handelDataAddress(event.target.value);
    } else {
      handelDataAddress("");
    }
  };
  const setUserBussinessGroupId = (e) => {
    handelDataAddressPart(e.target.value);
  };

  ///modal deleted

  const [showModalDelete, setShowModalDelete] = useState(false);

  const handelCloseModalDelete = () => setShowModalDelete(false);

  const [iditemDelete, setIditemDelete] = useState("");

  const handelDeleteBtn = (id) => {
    setIditemDelete(id);
    setShowModalDelete(true);
  };

  ///end modal delete

  //Moadale Add address

  const [showModaleForm, setShowModaleForm] = useState(isContractual);

  const handelCloseModaleForm = () => setShowModaleForm(false);

  const [idUpadteForm, setIdUpadteForm] = useState("");

  const [LodingUpdate, setLodingUpdate] = useState(false);

  const handelLodingUpdate = (status) => setLodingUpdate(status);

  const handelUpdate = (id) => {
    setIdUpadteForm(id);
    setShowModaleForm(true);
    setLodingUpdate(true);
  };
  const handelclaerid = () => {
    setIdUpadteForm("");
  };

  // end Moadale Add address
  return (
    <>
      {showModaleForm ? (
        <Row>
          <Col lg={12} md={12} xs={12}>
            <FormAddMoudal
              show={showModaleForm}
              handelClose={handelCloseModaleForm}
              idUpdate={idUpadteForm}
              id={id}
              LodingUpdate={LodingUpdate}
              handelLodingUpdate={handelLodingUpdate}
              handelReload={handelReload}
              handelclaerid={handelclaerid}
              isContractual={isContractual}
              close={close}
            />
          </Col>
        </Row>
      ) : (
        <>
          <Col lg='12' md='12' sm='12' style={{ marginTop: "1rem" }}>
            {JSON.parse(sessionStorage.getItem("customerid")) ? null : (
              <h5>آدرس ها</h5>
            )}
            <button
              type='button'
              className='btn btn-primary btn-icon-text btn-sm'
              onClick={() => setShowModaleForm(true)}
            >
              افزودن <i className='fa fa-plus fa-lg'></i>
            </button>
          </Col>

          <Row>
            {dataFech.map((item) => (
              <Col key={item.id} lg='6' md='6' sm='12' className='mt-2'>
                <Card>
                  <Card.Header className='d-flex'>
                    {isprofile ? null : (
                      <Form.Check
                        type='radio'
                        id={item.id}
                        name='addres'
                        onChange={handelOncheng}
                        label={item.districtName}
                        value={item.id}
                        checked={item.id === dataUpdate ? true : false}
                      />
                    )}
                    <div className='mr-auto d-flex'>
                      <p>
                        {item.personPositionName} {item.prefixName}{" "}
                        {item.fullName}
                      </p>
                      <p className='mr-2'>{item.cellPhone}</p>
                    </div>
                  </Card.Header>
                  <Card.Body className='p-4'>
                    <p>{item.placeTypeName}</p>
                    {item.userAddress}
                    {item.userBussinessGroup?.map(
                      ({
                        sectionName,
                        groupName,
                        slaveName,
                        userBusinessGroupId,
                      }) => (
                        <Form.Check
                          type='radio'
                          name='userBusinessGroupItem'
                          label={
                            <h5>
                              {sectionName} - {groupName} - {slaveName}
                            </h5>
                          }
                          onChange={setUserBussinessGroupId}
                          value={userBusinessGroupId}
                          id={userBusinessGroupId}
                          checked={
                            userBusinessGroupId === isSelectedAddressPart
                              ? true
                              : false
                          }
                        />
                      )
                    )}
                  </Card.Body>
                  <Card.Footer className='d-flex p-1'>
                    <Button
                      className='btn btn-inverse-success btn-fw'
                      onClick={() => handelUpdate(item.id)}
                    >
                      ویرایش <i className='mdi mdi-pencil'></i>
                    </Button>
                    <Button
                      className='btn btn-inverse-danger btn-fw mr-auto'
                      onClick={() => handelDeleteBtn(item.id)}
                    >
                      حذف <i className='mdi mdi-delete-forever'></i>
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
          {showModalDelete ? (
            <ModalDeleteAddress
              show={showModalDelete}
              handelClose={handelCloseModalDelete}
              iditemDelete={iditemDelete}
              handelReload={handelReload}
            />
          ) : null}
        </>
      )}
    </>
  );
}
